import postToLead from './lead-service';
import { ConsultationResponse } from '../../types/consultation';
import { applyCaptchaToPayload, normalizeCaptchaFromContactDetails } from './captcha-payload';
import { CaptchaController } from './captcha-v2';

type SubmitWithCaptchaOptions = {
  captcha?: CaptchaController;
  requireCaptcha?: boolean;
};

export async function postToLeadWithCaptcha(path: string, payload: Record<string, any>, { captcha, requireCaptcha = true }: SubmitWithCaptchaOptions = {}): Promise<ConsultationResponse | Error> {
  const token = captcha?.getToken();

  if (requireCaptcha && !token) {
    return new Error('error: captcha missing');
  }

  const normalizedPayload = normalizeCaptchaFromContactDetails(payload);
  const finalPayload = applyCaptchaToPayload(normalizedPayload, token);
  const response = await postToLead(path, finalPayload);

  if (response instanceof Error) {
    // Reset token on error so user can retry
    captcha?.reset();
    // Trigger the captcha widget to generate a new token for the next attempt
    captcha?.startIfNeeded();
  } else {
    captcha?.markTokenUsed();
  }

  return response;
}
